import {
  Box,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  Pagination,
  useTheme,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {
  CustomTableContainer,
  CustomTableHead,
  TableContentVendorFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import moment from "moment";
import empty from "../../../assets/illo.png";
import {
  ButtonLink,
  DisplayText,
} from "../../bankDetails/components/bankAccountsContent";
import PropTypes from "prop-types";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useDispatch, useSelector } from "react-redux";
import { getUsersList } from "../redux/companiesUserSlice";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  RemoveRedEye,
} from "@mui/icons-material";
import { Company } from "../../../CONSTANTS";
const EmptyContainer = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <br />
    <img src={empty} alt="empty" />

    <DisplayText> There are no companies to display</DisplayText>
    <br />
    <ButtonLink to="/app/add-user">+ Add Users</ButtonLink>
    <br />

    <br />
  </Grid>
);

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <>
      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    </>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function CompaniesUserTableContent({ search, clicked, setClicked }) {
  const [page, setPage] = React.useState(1);
  const [per_page, setPer_page] = React.useState(10);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { usersList, pagination, pending } = useSelector(
    (state) => state.companiesUser
  );

  const dispatch = useDispatch();
  const userList = () => {
    const payload = {
      per_page,
      page,
      search,
    };
    dispatch(getUsersList(payload));
    setClicked(false);
  };

  useEffect(() => {
    userList();
    // eslint-disable-next-line
  }, [page, rowsPerPage, per_page, clicked]);
  useEffect(() => {
    setPage(1);
  }, [per_page, clicked]);
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - usersList?.length) : 0;

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <CustomTableContainer component={Card}>
      {pending && <CircularProgress />}
      <Table aria-label="simple table">
        <CustomTableHead>
          <TableRow>
            <TableCell>
              <TableHeaderFont>Full Name</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>{Company} Name</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Contact Email</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Role</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Date</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Action</TableHeaderFont>
            </TableCell>
          </TableRow>
        </CustomTableHead>
        {usersList?.length !== 0 ? (
          <TableBody>
            {usersList?.map((row) => {
              return (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <Link
                      style={{ textDecoration: "none" }}
                      // eslint-disable-next-line
                      to={"/app/users/" + `${row.id}`}
                    >
                      <TableContentVendorFont>
                        {row.first_name !== null
                          ? row.first_name
                          : "Not Applicable"}{" "}
                        {row.last_name !== null
                          ? row.last_name
                          : "Not Applicable"}
                      </TableContentVendorFont>
                    </Link>
                  </TableCell>
                  <TableCell>
                    {row.company_name !== null
                      ? row.company_name
                      : "Not Applicable"}
                  </TableCell>
                  <TableCell>
                    {row.contact_person_email !== null
                      ? row.contact_person_email
                      : "Not Applicable"}
                  </TableCell>
                  <TableCell>
                    {row.roles !== null ? row.roles : "Not Applicable"}
                  </TableCell>
                  <TableCell>
                    {row.createdAt !== null
                      ? moment(row.createdAt).format("DD MMM YY")
                      : "Not Applicable"}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    <Link
                      style={{ textDecoration: "none" }}
                      // eslint-disable-next-line
                      to={"/app/users/" + `${row.id}`}
                    >
                      <RemoveRedEye
                        style={{
                          fill: "royalblue",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                    </Link>
                  </TableCell>
                </TableRow>
              );
            })}
            {emptyRows > 0 && (
              <TableRow style={{ height: 0 * emptyRows }}></TableRow>
            )}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell colSpan={8}>
                <CustomTableContainer>
                  <EmptyContainer />
                </CustomTableContainer>
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>

      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ height: "10vh", borderTop: "1px solid lightgray", px: 3 }}
      >
        <Grid item sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <span>Rows per page:</span>
          <select
            value={per_page}
            onChange={(e) => {
              setPer_page(e.target.value);
              setPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </Grid>

        <Grid item>
          <Pagination
            color="primary"
            variant="text"
            onChange={(_, newValue) => setPage(newValue)}
            count={pagination?.total_page}
            page={page}
            shape="rounded"
            showFirstButton
            showLastButton
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
    </CustomTableContainer>
  );
}

export default CompaniesUserTableContent;
